module.exports = __webpack_public_path__ + "img/thumb-008-10.4bd304ec.png";